import { SidebarNavItemsProps } from '@/sidebar/presentation/components/NavigationItem';
import { Box } from '@creditas-ui/layout';
import { ExitIcon } from './icons';
import { MenuItem } from './MenuItem';
import { Logout, LogoutButton } from './MenuExpandedContent.style';
import { removeSession } from '@/shared/application';

type MenuExpandedContentProps = {
  items: Array<SidebarNavItemsProps>;
  onItemClick: (item: SidebarNavItemsProps) => void;
};

export const MenuExpandedContent = ({
  items,
  onItemClick,
}: MenuExpandedContentProps): JSX.Element => {
  return (
    <Box data-testid="menu-expanded-content-list">
      {items.map((item, index) => (
        <Box key={`menu-item-${index}`} data-testid="menu-item">
          <MenuItem item={item} onItemClick={onItemClick} />
        </Box>
      ))}

      <Logout>
        <ExitIcon data-testid="logout-icon" />
        <LogoutButton
          onClick={removeSession}
          size="large"
          data-testid="logout-button"
        >
          Sair
        </LogoutButton>
      </Logout>
    </Box>
  );
};
